<template>
    <aside class="menu pt-6 pl-4">
        <!--<app-search-bar
            :placeholder="$t('Inspirations.search_placeholder')"
            class="mr-4"
        />-->
        <!--<div class="admin-actions mr-4 pb-5 mb-3" v-if="isAdmin">
            <button class="button is-primary is-medium is-fullwidth">
                {{ $t('Inspirations.add_new') }}
            </button>
        </div>-->
        <div
            ref="collapsibles"
            id="accordion_inspirations_filter"
            class="lb-accordion"
        >
            <article class="message mb-1 mr-4">
                <div class="message-header">
                    <a
                        href="#collapsible-message-accordion-competences"
                        data-action="collapse"
                    >
                        <div class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <p>
                                        {{ $t('Inspirations.key_competences') }}
                                    </p>
                                </div>
                            </div>
                            <div class="level-right">
                                <p class="level-item">
                                    <span class="icon is-medium">
                                        <i
                                            class="
                                                mdi mdi-18px mdi-chevron-down
                                            "
                                        ></i>
                                    </span>
                                    <!--<span class="icon is-medium" v-else>
                                        <i class="mdi mdi-18px mdi-chevron-up"></i>
                                    </span>-->
                                </p>
                            </div>
                        </div>
                    </a>
                </div>
                <div
                    id="collapsible-message-accordion-competences"
                    class="message-body is-collapsible"
                    data-parent="accordion_inspirations_filter"
                    data-allow-multiple="true"
                >
                    <div class="message-body-content">
                        <div
                            v-for="competency in competencies"
                            :key="competency"
                            class="py-2"
                        >
                            <label class="checkbox">
                                <input
                                    v-model="competency.selected"
                                    type="checkbox"
                                />
                                {{
                                    $t('Inspirations.competence.' + competency)
                                }}
                            </label>
                        </div>
                    </div>
                </div>
            </article>
            <article class="message mb-1 mr-4">
                <div class="message-header">
                    <a
                        href="#collapsible-message-accordion-subjects"
                        data-action="collapse"
                    >
                        <div class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <p>
                                        {{ $t('Inspirations.subjects') }}
                                    </p>
                                </div>
                            </div>
                            <div class="level-right">
                                <p class="level-item">
                                    <span class="icon is-medium">
                                        <i
                                            class="
                                                mdi mdi-18px mdi-chevron-down
                                            "
                                        ></i>
                                    </span>
                                    <!--<span class="icon is-medium" v-else>
                                        <i class="mdi mdi-18px mdi-chevron-up"></i>
                                    </span>-->
                                </p>
                            </div>
                        </div></a
                    >
                </div>
                <div
                    id="collapsible-message-accordion-subjects"
                    class="message-body is-collapsible"
                    data-parent="accordion_inspirations_filter"
                    data-allow-multiple="true"
                >
                    <div class="message-body-content">
                        <div
                            v-for="subject in subjects"
                            :key="subject"
                            class="py-2"
                        >
                            <label class="checkbox">
                                <input
                                    v-model="subject.selected"
                                    type="checkbox"
                                />
                                {{ $t('Inspirations.subject.' + subject) }}
                            </label>
                        </div>
                    </div>
                </div>
            </article>
            <article class="message mb-1 mr-4">
                <div class="message-header">
                    <a
                        href="#collapsible-message-accordion-project_types"
                        data-action="collapse"
                    >
                        <div class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <p>
                                        {{ $t('Inspirations.projects') }}
                                    </p>
                                </div>
                            </div>
                            <div class="level-right">
                                <p class="level-item">
                                    <span class="icon is-medium">
                                        <i
                                            class="
                                                mdi mdi-18px mdi-chevron-down
                                            "
                                        ></i>
                                    </span>
                                    <!--<span class="icon is-medium" v-else>
                                        <i class="mdi mdi-18px mdi-chevron-up"></i>
                                    </span>-->
                                </p>
                            </div>
                        </div>
                    </a>
                </div>
                <div
                    id="collapsible-message-accordion-project_types"
                    class="message-body is-collapsible is-active"
                    data-parent="accordion_inspirations_filter"
                    data-allow-multiple="true"
                >
                    <div
                        class="
                            message-body-content
                            columns
                            is-multiline
                            mx-0
                            px-0
                        "
                    >
                        <div
                            v-for="projectType in projectTypesFiltered"
                            :key="projectType.name"
                            class="
                                py-2
                                column
                                is-6
                                has-text-centered
                                px-0
                                mb-0
                                has-cursor-pointer
                            "
                        >
                            <div
                                :ref="projectType.name"
                                class="box mx-2 px-2 py-2"
                                @click.stop="
                                    selectProjectType(projectType.name)
                                "
                            >
                                <figure class="image is-2by1">
                                    <img :src="projectType.image" />
                                </figure>
                                <p>
                                    {{
                                        $t(
                                            'Inspirations.project_type.' +
                                                projectType.name
                                        )
                                    }}
                                </p>
                            </div>
                            <!--    <label class="checkbox">
                                <input v-model="projectType.selected" type="checkbox" />
                                {{ $t('Inspirations.project_type.' + projectType.name) }}
                            </label>-->
                        </div>
                    </div>
                </div>
            </article>
        </div>
    </aside>
</template>

<script>
import bulmaCollapsible from '@creativebulma/bulma-collapsible';
import _ from 'underscore';
import AppSearchBar from '@/components/AppSearchBar';
export default {
    components: {
        AppSearchBar,
    },
    props: {
        /*folders: {
            type: Array,
            default() {
                return [];
            },
            required: true,
        },
        activeFolder: {
            type: String,
            default: undefined,
        },*/
    },
    data() {
        return {
            competencies: this.$store.state.Inspirations.KEY_COMPETENCIES,
            subjects: this.$store.state.Inspirations.SUBJECTS,
            //projectTypes: this.$store.state.Project.PROJECT_TYPE,
        };
    },
    mounted() {
        const collapsibles = bulmaCollapsible.attach();
    },
    computed: {
        projectTypesFiltered() {
            return _.filter(
                this.$store.state.Project.PROJECT_TYPE,
                (projectType) => {
                    return projectType.available == true;
                }
            );
        },
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
    },
    methods: {
        selectProjectType(projectType) {
            if (this.$refs[projectType][0].classList.contains('selected')) {
                this.$refs[projectType][0].classList.remove('selected');
            } else {
                this.$refs[projectType][0].classList.add('selected');
            }
        },
        test(e) {
            console.log('test', e);
        },
    },
};
</script>

<style scooped>
.lb-accordion a {
    text-decoration: none !important;
    width: 100%;
}
.box.selected {
    border: 3px solid #0069bb;
}
.box:hover {
    border: 3px solid #0069bb;
}
.message-header {
    background-color: transparent;
    color: #0069bb;
    border-bottom: 1px solid #0069bb;
}
.message {
    background-color: transparent;
}
.lb-project-search-bar {
    border-radius: 9999px;
}
.lb-project-search-bar input {
    padding-top: 0.5rem !important;
}
.lb-project-search-bar span {
    padding-top: 0.25rem !important;
}
</style>
